import { connect } from 'react-redux';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
import { shouldRequireExplicitCookieConsent } from '../../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
const mapStateToProps = state => ({
  requiresExplicitConsentToProcess: getShowGdprConsentToProcess(state),
  requiresExplicitCookieConsent: shouldRequireExplicitCookieConsent(state)
});
const mapDispatchToProps = {};
export const withConsent = connect(mapStateToProps, mapDispatchToProps);